import { languageHelper } from "../../../../config/helperFunctions";
import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function AttendanceReport() {
  const [columns] = useState([
    {
      header: languageHelper("SN"),
      accessorKey: "SN",
    },
    {
      header: languageHelper("Reference No"),
      accessorKey: "Reference No",
    },
    {
      header: languageHelper("Date"),
      accessorKey: "Date",
    },

    {
      header: languageHelper("Employee"),
      accessorKey: "Employee",
    },
    {
      header: languageHelper("In Time"),
      accessorKey: "In Time",
    },
    {
      header: languageHelper("Out Time"),
      accessorKey: "Out Time",
    },
    {
      header: languageHelper("Time Count"),
      accessorKey: "Time Count",
    },
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: languageHelper("Submit"),
    },
  ]);

  const [selectButton] = useState([
    {
      placeholder: "Employee",
    },
  ]);
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Attendance Report")}
        buttonDataa={buttonDataa}
        selectButton={selectButton}
      />
    </main>
  );
}

export default AttendanceReport;
